import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";
import { keepPreviousData } from "@tanstack/react-query";

import { GetTestingProgramsTestingProgramIdActivitiesParams } from "api/generated/model";
import { useGetTestingProgramsTestingProgramIdActivities } from "api/generated/testing-programs/testing-programs";

export function useTestingActivitiesforProgramQuery(
    testingProgramId: number,
    archived: GetTestingProgramsTestingProgramIdActivitiesParams["archived"]
) {
    return useGetTestingProgramsTestingProgramIdActivities(
        testingProgramId,
        { archived },
        {
            query: {
                select: (response) => response.data,
                staleTime: STALE_TIME_RESOURCES,
                // Keep the previous rows on screen while a new (archived /
                // non-archived) result set loads, so toggling the filter shows
                // a spinner over the table instead of blanking the page.
                placeholderData: keepPreviousData,
            },
        }
    );
}
